<template>
    <div style="padding:20px;position:relative;">
        <div class="info-box">
            <el-image :src="avatar" style="width:90px;height:90px;border-radius:10px;margin-right: 20px;">
                <div slot="error" class="image-slot">
                    <img style="width: 100%;" :src="avatar" alt="">
                </div>
            </el-image>
            <div style="flex:1">
                <div><span>{{ teacherInfo.name }}</span></div>
                <div style="display: flex;">
                    <div style="width:150px">员工编号：{{ teacherInfo.employeeNo }}</div>
                    <div style="width:200px">部门：{{ teacherInfo.department }}</div>
                    <div>职位：{{ teacherInfo.post }}</div>
                </div>
                <div style="display: flex;">
                    <div style="width:150px"><svg-icon icon-class="phone" style="width:14px;height:14px;margin-right:4px;" />{{ teacherInfo.mobilePhone }}</div>
                    <div style="width:200px"><svg-icon icon-class="circulated" style="width:14px;height:14px;margin-right:4px;" />{{ teacherInfo.email }}</div>
                    <div style="width:150px"><svg-icon icon-class="dwzcyh" style="width:14px;height:14px;margin-right:4px;" />{{ formatBirthday(teacherInfo.birthDate) }}</div>
                    <div style="width:150px"><svg-icon icon-class="crm_mapp_kh" style="width:14px;height:14px;margin-right:4px;" />{{ formatStatus(teacherInfo.personStatus) }}</div>
                </div>
            </div>
        </div>
        <div style="position: relative;">
        <el-tabs v-model="activeTabName" class="demo-tabs" :before-leave="tabsBeforeLeave" style="flex: 5;">
            <el-tab-pane label="基本信息" name="User" />
            <el-tab-pane label="任职信息" name="Employment" />
            <el-tab-pane label="相关学历及职业技能证书" name="Certificate" />
            <el-tab-pane label="过往学习/工作经历" name="JobResume" />
            <el-tab-pane label="家庭成员" name="Family" />
            <el-tab-pane label="人事合同" name="Contract" />
        </el-tabs>
        <div
            v-if="activeTabName === 'User'"
            style="position: absolute;right: 10px;top: -5px;z-index: 1;"
>
            <el-button type="warning" @click="exportData()">导出</el-button>
            <el-button v-if="canEdit == 1" type="" @click="handleCancel">取消</el-button>
            <el-button v-if="canEdit == 1" type="primary" :loading="doing" @click="handleSubmit">提交</el-button>
            <el-button v-if="canEdit == 0" type="primary" @click="handleEdit">修改</el-button>
        </div>
        </div>
        <div v-if="activeTabName === 'User'">
            <div class="header">基本信息</div>
            <basicInfoForm ref="busiform" :can-edit="canEdit" />
        </div>
        <div v-else-if="activeTabName == 'Employment'" class="scroll-box">
            <div class="header">任职信息</div>
            <EmploymentTable :vo="teacherInfo" :data-type="'personal'" @handleSubmit="handleSubmit"></EmploymentTable>
        </div>
        <div v-else-if="activeTabName == 'Certificate'" class="scroll-box">
            <div class="header">相关学历及职业技能证书</div>
            <CertificateTable :vo="teacherInfo" :can-edit="1"></CertificateTable>
        </div>
        <div v-else-if="activeTabName == 'Family'" class="scroll-box">
            <div class="header">家庭成员</div>
            <FamilyTable :vo="teacherInfo" :can-edit="1"></FamilyTable>
        </div>
        <div v-else-if="activeTabName == 'JobResume'" class="scroll-box">
            <div class="header">过往学习/工作经历</div>
            <JobResumeTable :vo="teacherInfo" :can-edit="1"></JobResumeTable>
        </div>
        <div v-else-if="activeTabName == 'Contract'" class="scroll-box">
            <div class="header">人事合同</div>
            <ContractTable :vo="teacherInfo"></ContractTable>
        </div>

        <div v-if="activeTabName === 'User'" style="width:100%;height:80px;"></div>
        <!-- <div
v-if="activeTabName === 'User'"
            style="width:100%;padding:20px 0;position:absolute;bottom:10px;text-align:center;display:flex;justify-content:center;"
>
            <el-button v-if="canEdit == 1" type="" @click="handleCancel">取消</el-button>
            <el-button v-if="canEdit == 1" type="primary" :loading="doing" @click="handleSubmit">提交</el-button>
            <el-button v-if="canEdit == 0" type="primary" @click="handleEdit">修改</el-button>
        </div> -->

    </div>
</template>

<script>
const moment = require('moment')
// import EmploymentTable from './table/employmentTable'
import EmploymentTable from './components/employmentForm'
import CertificateTable from './table/certificateTable'
import JobResumeTable from './table/jobResumeTable'
import ContractTable from './table/contractTable'
import FamilyTable from './table/familyTable'
import basicInfoForm from './components/basicInfoForm'
import { mapGetters } from 'vuex'
export default {
    components: {
        EmploymentTable,
        CertificateTable,
        JobResumeTable,
        ContractTable,
        FamilyTable,
        basicInfoForm
    },
    props: {},
    data: function () {
        return {
            imageSrc: '',
            vo: {},
            // showView: 'mainform',
            //  moduleInfo: {"formTemplate":"dcontent/busiformurl?vwtype=W&url=/xsgl/archiveInfo/formAdd.html","addNewUrl":"xsgl/rsglArchiveInfo/addNew","insertUrl":"xsgl/rsglArchiveInfo/insert","getByIdUrl":"xsgl/rsglArchiveInfo/getById","updateUrl":"xsgl/rsglArchiveInfo/update","delUrl":"xsgl/rsglArchiveInfo/delete","listDataUrl":"xsgl/rsglArchiveInfo/listdata","winWidth":1000,"winHeight":600,"moduleCode":"archiveInfo","openViewType":"0","listAdvSearchAllFields":0,"listAdvSearchExpandPanel":0},
            teacherInfo: {},
            canEdit: 0,
            doing: false,
            activeTabName: 'User',
            loginUser: this.$store.getters.loginUser
        }
    },
    computed: {
        ...mapGetters(['avatar'])
    },
    watch: {},
    created: function () {
        this.$bus.emit('showNavSearch', false)
        this.getInfo()
        //列表页面配置ID
        // let formurl = this.moduleInfo.formTemplate.split("url=")[1]
        // formurl = formurl.replace(/\//g, ".")
        // formurl = "#/dcontent/vuebusiform/W/" + formurl.substring(1).replace(".html", ".vue")
        // formurl += "?sysCode=" + (this.$route.meta.sysCode || "")
        // this.$options.components['BusiForm'] = this.$loadComponent(formurl)
    },
    beforeDestroy: function () {
        this.$bus.emit('showNavSearch', true)
    },
    mounted: function () { },
    methods: {
        exportData() {
            window.open('/apigw/xsgl/rsglArchiveInfo/exportArchiveInfoFileById?id=' + this.teacherInfo.id)
        },
        formatStatus(val) {
            if (val == 0) {
                return '实习'
            } if (val == 2) {
                return '试用'
            } if (val == 3) {
                return '正式'
            } if (val == 4) {
                return '退休'
            } if (val == 5) {
                return '离职'
            }
        },
        formatBirthday(val) {
            return moment(val).format('YYYY-MM-DD')
        },
        handleEdit() {
            this.canEdit = 0
            setTimeout(() => {
                this.canEdit = 1
            }, 100)
        },
        handleCancel() {
            this.canEdit = 0
        },
        upLoadImage() {
            this.$app.upload('/xsgl/rsglArchiveInfo/upload', this.teacherInfo.fileList[0].raw, { 'id': this.teacherInfo.fileList[0].id, 'nameField': 'idPhotoName', 'dataField': 'idPhoto' }).then(res => {
                if (res.code == 'success') {
                    //this.$message({ type: 'success', message: '保存成功！' })
                } else {
                    this.$message.error('文件保存失败！')
                }
            })
        },
        handleSubmit(callback = () => { }) {
            if (this.activeTabName === 'User') {
                this.teacherInfo = Object.assign(this.teacherInfo, this.$refs.busiform.vo)
            }
            if (this.teacherInfo?.passenger?.appointmnetInfos?.length) {
                this.teacherInfo.passenger.appointmnetInfos = this.teacherInfo.passenger.appointmnetInfos.filter(item => item.department)
            }
            this.formValidate(() => {
                this.doing = true
                this.$http({
                    method: 'put',
                    url: '/xsgl/rsglArchiveInfo/update',
                    data: this.teacherInfo
                }).then(res => {
                    if (res.code == 'success') {
                        this.$message({ type: 'success', message: '保存成功！' })
                        this.canEdit = 0
                        this.doing = false
                        this.getInfo()
                        // this.upLoadImage()
                        callback(true)
                    } else {
                        this.$message.error(res.message)
                        callback(false)
                    }
                    this.doing = false
                })
            }, null, 1)
        },
        changeTab: function (val) {
            console.log('val', val)
            this.activeTabName = val.name
        },
        tabsBeforeLeave(activeName, oldActiveName) {
            if (oldActiveName === 'User' && !this.teacherInfo.id) {
                this.$message.error('请先保存基本信息')
                return false
            }
            return true
        },
        /**
    * 表单打开检查，vo为已加载archiveInfo对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
    */
        onBasicFormBeforeOpen: function ($scope, vo, defer) {
            console.log('archiveInfo form before open', $scope)
            defer.resolve(true)
        },
        /**
    * 表单打开完成，vo为已加载的archiveInfo对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
    */
        onBasicFormOpened: function ($scope, vo) {
            console.log('archiveInfo form opened')
        },
        /**
    * 表单提交事件，可执行业务数据高级校验，vo为待提交的archiveInfo对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
    */
        onBasicFormBeforeSubmit: function ($scope, vo, defer) {
            /*this.$confirm('您是否确认提交保存?', '确认操作', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
      })
      .then(() => {
        defer.resolve(true)
      })
      .catch(err => {
        defer.reject(err)
      })*/

            console.log('archiveInfo form submit validation success')
            defer.resolve(true)
        },
        /**
    * 表单提交完成，vo为已保存成功的archiveInfo对象，窗口即将关闭，不需要返回值
    */
        onBasicFormSubmited: function ($scope, vo) {
            console.log('archiveInfo form submited')
        },
        getInfo() {
            this.$http({
                method: 'post',
                url: '/xsgl/rsglArchiveInfo/listdata?urlsearch=userId:' + this.loginUser.userId
            }).then(res => {
                if (res.code == 'success') {
                    const { list } = res.body.pageInfo
                    if (!Array.isArray(list) || list.length == 0) {
                        return
                    }
                    let _id = list[0].id

                    this.$http({
                        method: 'get',
                        url: '/xsgl/rsglArchiveInfo/getById?id=' + _id
                    }).then(res => {
                        if (res.code == 'success') {
                            this.teacherInfo = res.body.vo
                            this.imageSrc = `${location.origin}${process.env.VUE_APP_BASE_API}/xsgl/rsglArchiveInfo/download?dataField=idPhoto&nameField=idPhotoName&id=${this.teacherInfo.id}&httpPort=${location.port}`
                        }
                    })
                }
            })
        }

    }
}
</script>

<style scoped>
.info-box {
    padding: 10px 10px 40px 0;
    font-size: 14px;
    display: flex;
    line-height: 30px;
}

.header {
    padding: 10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
    font-weight: 600;
}

.scroll-box {
    /* height: 400px; */
    overflow-y: auto;
}
</style>
